/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum LaundryGroupStatisticsFactType {
    ABSOLUTE = 'REVENUE_ABSOLUTE',
    PERCENTAGE_CHANGE = 'REVENUE_PERCENTAGE_CHANGE'
}


export function LaundryGroupStatisticsFactTypeFromJSON(json: any): LaundryGroupStatisticsFactType {
    return LaundryGroupStatisticsFactTypeFromJSONTyped(json, false);
}

export function LaundryGroupStatisticsFactTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): LaundryGroupStatisticsFactType {
    return json as LaundryGroupStatisticsFactType;
}

export function LaundryGroupStatisticsFactTypeToJSON(value?: LaundryGroupStatisticsFactType | null): any {
    return value as any;
}

